import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { portfolioType } from "utils/constantValues";
import useNotify from "hooks/useNotify";
import { actions } from "store/actions";
import profileApi from "api/profile";
import { scrollIntoView } from "utils/helper";

function usePortfolioFiles({ profileCompletionRef = {} }) {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});
  const currentPortfolioIds =
    userDetails?.userFiles
      ?.filter((file) => file.type === portfolioType)
      ?.map((file) => file.id) ?? [];

  const { notifyError, notifySuccess } = useNotify();
  const [isLoading, setIsLoading] = useState(false);
  const [isEditPortfolioFiles, setIsEditPortfolioFiles] = useState(false);

  profileCompletionRef.portfolio = {
    openEdit: setIsEditPortfolioFiles,
    portfolio: currentPortfolioIds,
  };

  const onEditPortfolioFiles = async (values) => {
    try {
      setIsLoading(true);
      const agencyId = userDetails?.agencyId;
      const { newCreated, deleted } = values;

      const deletedIds = deleted?.map((el) => el.fileId) ?? [];

      const payload = {
        newCreated:
          newCreated
            ?.filter(
              (el) =>
                !deletedIds.includes(el.fileId) &&
                !currentPortfolioIds.includes(el.fileId)
            )
            ?.map((el) => el.fileId) ?? [],
        deleted: deletedIds,
        type: portfolioType,
      };

      await profileApi.updateAgencyFiles(agencyId, payload);
      const userData = await profileApi.getUserProfileByIdApi(userDetails?.id);

      dispatch(actions.setUserDetails(userData));
      setIsEditPortfolioFiles(false);
      notifySuccess("Has been updated successfully");
      scrollIntoView("portfolioScrollId");
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  const resetOnUnmount = () => {};
  useEffect(() => {
    return () => {
      resetOnUnmount();
    };
  }, []);

  return {
    isEditPortfolioFiles,
    setIsEditPortfolioFiles,
    onEditPortfolioFiles,
    isPortfolioLoading: isLoading,
  };
}

export default usePortfolioFiles;
